<template>
  <div v-if="releases.length" class="mb-5">
    <h1 class="fz-24">{{ $t('courses.regularCourses') }}</h1>
    <div class="new-releases-grid">
      <div
        v-for="(data, i) in releases"
        :key="`new-${i}`"
        class="grid-item"
        @click="$router.push(`/course/${data.id}`)"
      >
        <div class="course-card">
          <AppImg
            :img-src="getCourseImage(data)"
            img-alt="course banner"
            border-radius="10px"
            class="course-image"
          />
          <div class="course-info">
            <h3 class="course-title">{{ data.title || data.course_title }}</h3>
            <p class="course-description" v-html="getShortDescription(data)"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppImg from '@/components/common/AppImg.vue';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { getSmallestSizeImage } from '@/helpers/functions';

export default {
  name: 'CoursesReleasesGrid',

  components: {
    AppImg,
  },

  setup() {
    const store = useStore();
    const releases = computed(() => {
      return store.getters['newReleases/getNewReleasesHome'];
    });

    const getCourseImage = (course) => {
      return getSmallestSizeImage(course.media)?.url ?? null;
    };

    const getShortDescription = (course) => {
      const description = course.course_introduction || course.description || '';
      const maxLength = 100;
      
      // Strip HTML tags for preview
      const strippedDescription = description.replace(/<[^>]*>/g, '');
      
      if (strippedDescription.length > maxLength) {
        return strippedDescription.substring(0, maxLength) + '...';
      }
      
      return strippedDescription;
    };

    return {
      releases,
      getCourseImage,
      getShortDescription,
    };
  },
};
</script>

<style scoped lang="scss">
.new-releases-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 16px;
}

.grid-item {
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.course-card {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.course-image {
  width: 100%;
  height: 150px;
  margin-bottom: 12px;
  
  :deep(img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.course-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.course-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.course-description {
  font-size: 14px;
  font-weight: 300;
  line-height: 1.4;
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
